import { useEffect, useState } from "react";
import { DataTable } from "../../DataTable/DataTable";
import defaultAvatar from "../../../assets/images/default_avatar.jpg";
import { AddNewDeliveryAgentModal } from "../../../shared/AddNewDeliveryAgentModal";
import { useDriver } from "./Driver/DriverContext";
import { DeliveryBoyPopUpDetails } from "./Driver/DeliveryBoyPopUpDetails";
import { ClinicDriverService } from "../../../services/api/clinic.driver.service";
import { useAuth } from "../../../context/AuthContext";
import { Edit3, Eye } from "lucide-react";
import DriverUpdateComponent from "./Driver/updateDriver.tsx/updateDetails";

export interface DeliveryAgentInterface {
  id: string;
  clinicId: string;
  profilePicture?: string;
  education?: string;
  dateOfBirth?: string;
  address?: string;
  aadharFrontImage?: string;
  aadharBackImage?: string;
  dlFrontImage?: string;
  dlBackImage?: string;
  vehicleRcFront?: string;
  vehicleRcBack?: string;
  vehicleBrand?: string;
  vehicleNumber?: string;
  drivingLicence?: string;
  vehicleInsurance?: string;
  blocked?: boolean;
  isAvailable?: boolean;
  lastOrderTime?: string;
  type?: string;
  createdAt?: string;
  updatedAt?: string;
  role?: string;
  name: string;
  aadharNumber?: string;
  mobileNumber: string;
  email?: string;
  username?: string;
  password?: string;
}

export function OrdersDeliveryBoys({handleUpdateButton,handleViewButton}) {
  const { user } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const [driverList, setDriverList] = useState<DeliveryAgentInterface[]>([]);
  const [showAddDriverModal, setShowAddDriverModal] = useState(false);
  const[pageSize,setPageSize]=useState(10);
  const [selectedDriver, setSelectedDriver] =
    useState<DeliveryAgentInterface | null>(null);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
    totalCount: 0,
    totalPages: 0,
  });

  const { type, dispatch } = useDriver();
  const clinicId = user?.role === "clinic" ? user?.id : "";

  const fetchDrivers = async () => {
    try {
      setIsLoading(true);
      const response = await ClinicDriverService.getDriverListing(
        pagination.page,
        pageSize,
        clinicId,
        { type: "driver" }
      );

      console.log("Order delivery", response);
      if (response.data) {
        setDriverList(response.data || []);
        setPagination({
          ...pagination,
          totalCount: response.pagination.totalItems,
          totalPages: response.pagination.totalPages,
        });
      }
    } catch (error) {
      console.error("Failed to fetch drivers:", error);
    } finally {
      setIsLoading(false);
    }
  };

  

  useEffect(() => {
    fetchDrivers();
  }, [pagination.page, pageSize]);
  const handleCloseSummaryForm = () => {
    setSelectedDriver(null);
    dispatch({ type: "CLOSE_FORM" });
  };

  const handlePageChange = (page: number) => {
    setPagination({ ...pagination, page });
  };

  const addDeliveryAgentButton = "";

  const columns = [
    {
      key: "name",
      title: "Driver Name",
      sortable: true,
      width: "w-[200px]",
      render: (driver: DeliveryAgentInterface) => (
        <div className="flex items-center">
          <img
            src={driver.profilePicture || defaultAvatar}
            alt={driver.name}
            className="w-8 h-8 rounded-full mr-3 object-cover border border-gray-200"
          />
          <div className="font-medium text-gray-900">{driver.name}</div>
        </div>
      ),
    },
    {
      key: "mobileNumber",
      title: "Phone Number",
      width: "w-[150px]",
      render: (driver: DeliveryAgentInterface) => (
        <div className="text-sm font-medium">{driver.mobileNumber}</div>
      ),
    },
    {
      key: "email",
      title: "Email",
      width: "w-[200px]",
      render: (driver: DeliveryAgentInterface) => (
        <div className="text-sm font-medium">{driver.email || 'N/A'}</div>
      ),
    },
    {
      key: "vehicleBrand",
      title: "Vehicle Brand",
      width: "w-[150px]",
      render: (driver: DeliveryAgentInterface) => (
        <div className="text-sm font-medium">{driver.vehicleBrand || 'N/A'}</div>
      ),
    },
    {
      key: "vehicleNumber",
      title: "Vehicle Number",
      width: "w-[150px]",
      render: (driver: DeliveryAgentInterface) => (
        <div className="text-sm font-medium">{driver.vehicleNumber || 'N/A'}</div>
      ),
    },
    {
      key: "status",
      title: "Status",
      width: "w-[100px]",
      render: (driver: DeliveryAgentInterface) => (
        <div className="text-sm font-medium">
          {driver.blocked ? (
            <span className="text-red-500">Blocked</span>
          ) : driver.isAvailable ? (
            <span className="text-green-500">Available</span>
          ) : (
            <span className="text-yellow-500">Busy</span>
          )}
        </div>
      ),
    },
    {
      key: "actions",
      title: "Actions",
      width: "w-[200px]",
      render: (driver: DeliveryAgentInterface) => (
        <div className="flex items-center gap-4">
          {/* Edit */}
          <button
            className="text-green-600 hover:text-green-700"
            onClick={() => handleUpdateButton(driver.id)}
          >
            <Edit3 className="w-5 h-5" />
          </button>
          <button
            className="text-green-600 hover:text-green-700"
            onClick={() => {
              handleViewButton(driver.id);
            }}
          >
            <Eye className="w-5 h-5" />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="relative">
      {/* {selectedDriver && (
        <DeliveryBoyPopUpDetails
          driver={selectedDriver}
          onCancel={handleCloseSummaryForm}
        />
      )} */}

      {showAddDriverModal && (
        <AddNewDeliveryAgentModal
          onClose={() => setShowAddDriverModal(false)}
          driverType="driver"
          refreshList={fetchDrivers}
        />
      )}
      
        <DataTable
          data={driverList}
          columns={columns}
          isLoading={isLoading}
          customFilters={addDeliveryAgentButton}
          pagination={{
            currentPage: pagination.page,
            totalPages: pagination.totalPages,
            setCurrentPage: handlePageChange,
            pageSize,
            setPageSize
          }}
        />
      
    </div>
  );
}
